import { render } from "./InputEmail.vue?vue&type=template&id=3eb158fd"
import script from "./InputEmail.vue?vue&type=script&lang=js"
export * from "./InputEmail.vue?vue&type=script&lang=js"
script.render = render

export default script